<template>
    <div class="order_common order_address">
        <div class="order_address_left" v-if="addressInfo && addressInfo.name">
            <h3>{{ addressInfo.name }} {{ addressInfo.phone }}</h3>
            <p>{{ addressInfo.province + addressInfo.city + addressInfo.area + addressInfo.address }}</p>
        </div>
        <div class="order_address_left order_address_select" v-else>
            请选择地址
        </div>
        <div class="order_address_right order_arrow">
            <van-icon name="arrow" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        addressInfo: {
            type: null,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>
.order {
    &_address {
        display: flex;
        justify-content: space-between;
        background: #fff;
        font-size: 32px;
        &_left {
            h3 {
                color: #000;
                margin-bottom: 22px;
            }
            p {
                color: #666;
            }
        }
        &_select {
            height: 100px;
            line-height: 100px;
        }
        &_right {
            display: flex;
            align-items: center;
        }
    }
    &_common {
        padding: 32px;
    }
}
</style>